import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFileUploadFeatureFromConfig } from '../../states/features/selectors';

const mapState = (state, props) => getFileUploadFeatureFromConfig(state, props.path);

const FileUploadFeatureFlag = ({ children, faq, template, maxRecords, isFeatureEnabled }) => {
	if (!isFeatureEnabled) return null;
	return React.cloneElement(children, {
		faq,
		template,
		maxRecords,
	});
};

FileUploadFeatureFlag.propTypes = {
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
	isFeatureEnabled: PropTypes.bool.isRequired,
	faq: PropTypes.string.isRequired,
	template: PropTypes.string.isRequired,
	maxRecords: PropTypes.number.isRequired,
};

export default connect(mapState)(FileUploadFeatureFlag);
